/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AdminStockManageSummaryResVo } from './AdminStockManageSummaryResVo';
import {
    AdminStockManageSummaryResVoFromJSON,
    AdminStockManageSummaryResVoFromJSONTyped,
    AdminStockManageSummaryResVoToJSON,
    AdminStockManageSummaryResVoToJSONTyped,
} from './AdminStockManageSummaryResVo';

/**
 * 
 * @export
 * @interface ResponseAdminStockManageSummaryResVo
 */
export interface ResponseAdminStockManageSummaryResVo {
    /**
     * 接口状态码
     * @type {number}
     * @memberof ResponseAdminStockManageSummaryResVo
     */
    code?: number;
    /**
     * 接口返回消息
     * @type {string}
     * @memberof ResponseAdminStockManageSummaryResVo
     */
    message?: string;
    /**
     * 
     * @type {AdminStockManageSummaryResVo}
     * @memberof ResponseAdminStockManageSummaryResVo
     */
    data?: AdminStockManageSummaryResVo;
}

/**
 * Check if a given object implements the ResponseAdminStockManageSummaryResVo interface.
 */
export function instanceOfResponseAdminStockManageSummaryResVo(value: object): value is ResponseAdminStockManageSummaryResVo {
    return true;
}

export function ResponseAdminStockManageSummaryResVoFromJSON(json: any): ResponseAdminStockManageSummaryResVo {
    return ResponseAdminStockManageSummaryResVoFromJSONTyped(json, false);
}

export function ResponseAdminStockManageSummaryResVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseAdminStockManageSummaryResVo {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : AdminStockManageSummaryResVoFromJSON(json['data']),
    };
}

export function ResponseAdminStockManageSummaryResVoToJSON(json: any): ResponseAdminStockManageSummaryResVo {
    return ResponseAdminStockManageSummaryResVoToJSONTyped(json, false);
}

export function ResponseAdminStockManageSummaryResVoToJSONTyped(value?: ResponseAdminStockManageSummaryResVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message'],
        'data': AdminStockManageSummaryResVoToJSON(value['data']),
    };
}

